import { render, staticRenderFns } from "./radioAccidentDialog.vue?vue&type=template&id=b17955a2&scoped=true"
import script from "./radioAccidentDialog.vue?vue&type=script&lang=js"
export * from "./radioAccidentDialog.vue?vue&type=script&lang=js"
import style0 from "./radioAccidentDialog.vue?vue&type=style&index=0&id=b17955a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17955a2",
  null
  
)

export default component.exports